var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.012 6.71438C7.25958 6.71438 7.48905 6.59676 7.75475 6.32436L13.0084 0.994125C12.7849 0.771258 12.3683 0.666016 11.7705 0.666016H2.04823C1.54098 0.666016 1.1847 0.765068 0.985426 0.969362L6.26924 6.32436C6.5289 6.59057 6.75837 6.71438 7.012 6.71438ZM0.484218 10.336L4.75354 6.00863L0.472141 1.6813C0.381561 1.85464 0.333252 2.1518 0.333252 2.57896V9.41355C0.333252 9.85309 0.381561 10.1626 0.484218 10.336ZM13.5217 10.3298C13.6183 10.1502 13.6666 9.8469 13.6666 9.41355V2.57896C13.6666 2.16418 13.6183 1.86702 13.5337 1.69987L9.26441 6.00863L13.5217 10.3298ZM2.22939 11.3327H11.9516C12.4589 11.3327 12.8091 11.2336 13.0084 11.0355L8.65451 6.61533L8.25596 7.03011C7.83929 7.4387 7.44678 7.62442 7.012 7.62442C6.57118 7.62442 6.17866 7.4387 5.76803 7.03011L5.36345 6.61533L1.02166 11.0293C1.25113 11.2336 1.64968 11.3327 2.22939 11.3327Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail.a83e00a758d79bda1b84fcd41b29f0d0.svg";